import { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Select,
    FormControl,
    FormLabel,
    Box,
} from "@chakra-ui/react";
import { Carrier, Policy } from "@bluefalcon/clients-management-client-fetch";
import { SearchableDropdown } from "../components/base/searchable-dropdown/searchable-dropdown.comp";
import { carriersService } from "../services";
import { toast } from "../utils/toast.utils";

type ImportPolicyCountiesModalProps = {
    policy: Policy;
    isOpen: boolean;
    onClose: () => void;
};

export const ImportPolicyCountiesModal = ({
    policy,
    isOpen,
    onClose,
}: ImportPolicyCountiesModalProps) => {

    const [selectedPolicy, setSelectedPolicy] = useState<Policy>();
    const [carrier, setCarrier] = useState<Carrier>()

    const handleSubmit = async () => {
        if (!selectedPolicy) {
            toast('Something went wrong', 'error');
            return;
        }
        const countyIds = selectedPolicy.states?.flatMap((st) => st.counties.map((county) => county.id)) ?? [];
        if (countyIds.length === 0) {
            toast('Something went wrong', 'error');
            return;
        }
        await carriersService.updatePolicyById(policy.id, {
            id: policy.id,
            county: {
                add: countyIds,
            },
        });
        toast('Imported');
        onClose();
    };

    const getCarrierById = async () => {
        const res = await carriersService.getCarrierById(policy.carrierId);
        setCarrier(res);
    };

    const onSelectPolicy = (name?: string) => {
        const found = carrier?.policies.find((p) => p.name === name);
        setSelectedPolicy(found);
    };

    useEffect(() => {
        getCarrierById();
    }, []);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Import Counties</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl>
                        <FormLabel htmlFor="role">Select Policy</FormLabel>
                        <SearchableDropdown
                            value={selectedPolicy?.name}
                            items={carrier?.policies.map((p) => p.name) ?? []}
                            placeholder="Policy"
                            onSelect={onSelectPolicy}
                        />
                    </FormControl>
                    <Box>
                        {selectedPolicy?.states
                            ? selectedPolicy.states.reduce<number>((acc, state) => acc + state.counties.length, 0)
                            : ''}
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="warn" onClick={handleSubmit}>Import</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
